import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { cn, cva } from '@lib/utils';

const inputErrorMsgVariants = cva([
  // Layout
  'mt-1',
  // Typography
  'text-xs',
  // Color (uses Radix error scale via this:error + semantic utility)
  'this:error text-this-text',
]);

type InputErrorMsgProps = {
  when: boolean;
  children: ReactNode;
} & Omit<ComponentPropsWithoutRef<'span'>, 'children'>;

function InputErrorMsg({ when, children, className, ...rest }: InputErrorMsgProps) {
  return when ? (
    <span className={cn(inputErrorMsgVariants(), className)} {...rest}>
      {children}
    </span>
  ) : null;
}

export { InputErrorMsg };
export type { InputErrorMsgProps };
